<template>
  <div class="nav fixed">
    <v-container>
      <nav>
        <v-row class="items-center align-center pdr-1" no-gutters>
          <v-col cols="12">
            <div @click="goIndex" class="d-flex items-center">
              <img height="48px" :src="logo" />
            </div>
          </v-col>
        </v-row>
      </nav>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import isBNN from '@/config/isBnn'

export default {
  name: 'Header',

  data() {
    return {
      isDev: process.env.VUE_APP_ENV !== 'production',
    }
  },

  computed: {
    ...mapState({
      campaign: state => state?.campaign?.current?.data,
    }),

    campaignName() {
      const notShow = ['PreRegister', 'CountDown']
      let hasNotShow = false
      for (const item of notShow) {
        if (this.$route?.name?.indexOf(item) > -1) {
          hasNotShow = true
          break
        }
      }
      return !hasNotShow ? this.campaign?.name ?? '' : ''
    },

    logo() {
      return isBNN
        ? require('@/assets/bnn/bnn.svg')
        : require('@/assets/logocom7.png')
    },
  },

  methods: {
    goIndex() {
      this.$store.commit('cart/resetCouponCode')

      if (this.$route?.params?.slug) {
        this.$router
          .push({
            name: 'ProductDetail',
            params: { slug: this.$route?.params?.slug },
          })
          .catch(() => true)
      } else if (localStorage.getItem('productLatestVisit')) {
        this.$router
          .push({
            name: 'ProductDetail',
            params: {
              slug: localStorage.getItem('productLatestVisit'),
            },
          })
          .catch(() => true)
      } else {
        this.$router
          .push({
            path: '/',
          })
          .catch(() => true)
      }
    },
  },
}
</script>

<style lang="stylus">

.nav
  width: 100%
  margin: 0
  z-index: 10
  background-color: white
  box-shadow: 0px 1px 3px #00000029;
  height: 80px
  display: flex;
  align-items: center;
  @media small
     padding: 1rem 0
  @media medium
     padding: 1rem 0

.fixed
  position: fixed

@media small
  .logo
    height: 30px

@media medium
  .logo
    height: 30px

  .text-head
    font-size: 1rem !important

.text-color-bnn
  color: $color-bnn
</style>
